export default __webpack_public_path__ + "static/media/1128040325510216.476eb01f.jpg";